// The only persisted PIN-session state is this per-tab online credential and expiry.
const key = 'sqi-pin-app-session';
export function hasPinSession() {
  return sessionStorage.getItem(key) !== null;
}
export function storedPinCredential(): { token: string; expiresAt: string } | null {
  try {
    const value = JSON.parse(sessionStorage.getItem(key) ?? 'null') as {
      token?: unknown;
      expiresAt?: unknown;
    } | null;
    if (
      !value ||
      Object.keys(value).sort().join(',') !== 'expiresAt,token' ||
      typeof value.token !== 'string' ||
      !/^[A-Za-z0-9_-]{43}$/.test(value.token) ||
      typeof value.expiresAt !== 'string' ||
      !Number.isFinite(Date.parse(value.expiresAt))
    )
      return null;
    return { token: value.token, expiresAt: value.expiresAt };
  } catch {
    return null;
  }
}
export function pinCredential() {
  const value = storedPinCredential();
  return value && Date.parse(value.expiresAt) > Date.now() && navigator.onLine ? value : null;
}
export function takePinSessionForCallback(pending: boolean) {
  if (!pending) return null;
  const previous = storedPinCredential();
  clearPinSession();
  return previous;
}
export function installPinSession(value: { token: string; expiresAt: string }) {
  if (
    !/^[A-Za-z0-9_-]{43}$/.test(value.token) ||
    !Number.isFinite(Date.parse(value.expiresAt)) ||
    Date.parse(value.expiresAt) <= Date.now()
  )
    throw Error('invalid_session');
  sessionStorage.setItem(key, JSON.stringify({ token: value.token, expiresAt: value.expiresAt }));
}
export function clearPinSession() {
  sessionStorage.removeItem(key);
}
